import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

const HelpPage: React.FC = () => (
  <div>
    <Container className="mt-4">
      <Row>
        <Col md={4}>This is help</Col>
      </Row>
    </Container>
  </div>
)

export default HelpPage
